import axios from 'axios';

// Create a separate axios instance for auth checking without interceptors
const authCheckAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

export interface User {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  is_active: boolean;
  is_verified: boolean;
  email_verified_at?: string;
  created_at: string;
  updated_at: string;
}

export const checkAuthStatus = async (): Promise<User | null> => {
  try {
    const response = await authCheckAPI.get('/web/v1/users/profile');
    return response.data.data;
  } catch (error) {
    return null;
  }
};